<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/media.jpg')"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h1 class="title">Media Contents</h1>
        </div>
      </div>
    </div>
    <div class="section media-portfolio-section">
      <div class="container">
        <div class="media-inquiry">
          <div class="media-inquiry-copy">
            <h2>전하고 싶은 이야기가 있나요?</h2>
            <p>영상 제작 상담은 크몽에서 편하게 문의해주세요.</p>
          </div>
          <a
            href="https://kmong.com/gig/784950"
            target="_blank"
            rel="noopener noreferrer"
            class="media-inquiry-link"
          >
            영상제작 문의 <span aria-hidden="true">↗</span>
          </a>
        </div>
        <div class="media-toolbar">
          <div class="media-search">
            <i class="now-ui-icons ui-1_zoom-bold"></i>
            <input
              v-model.trim="searchQuery"
              type="text"
              class="form-control"
              placeholder="제목, 카테고리, 설명으로 검색"
            />
          </div>
          <p class="media-result-count">
            {{ filteredVideos.length }}개의 영상
            <span v-if="searchQuery">· "{{ searchQuery }}" 검색 결과</span>
          </p>
        </div>
        <div class="media-filters">
          <button
            type="button"
            class="media-filter-btn"
            :class="{ active: selectedCategory === 'All' }"
            @click="setCategory('All')"
          >
            All
          </button>
          <button
            v-for="category in categories"
            :key="category"
            type="button"
            class="media-filter-btn"
            :class="{ active: selectedCategory === category }"
            @click="setCategory(category)"
          >
            {{ category }}
          </button>
        </div>
        <div class="separator separator-primary"></div>
        <div class="row media-grid-row">
          <div
            v-for="video in paginatedVideos"
            :key="video.title"
            class="col-lg-4 col-md-6"
          >
            <article class="media-card" @click="openVideo(video)">
              <div class="media-thumb-wrapper">
                <img
                  :src="getThumbnailUrl(video.url)"
                  :alt="video.title"
                  class="media-thumb"
                />
                <div class="media-play">
                  <i class="now-ui-icons media-1_button-play"></i>
                </div>
              </div>
              <div class="media-card-body">
                <p class="media-category">{{ video.category }}</p>
                <h3>{{ video.title }}</h3>
                <p class="media-summary">{{ video.description }}</p>
              </div>
            </article>
          </div>
        </div>
        <div v-if="!paginatedVideos.length" class="media-empty text-center">
          <h4>검색 결과가 없습니다.</h4>
          <p>다른 키워드로 다시 검색해보세요.</p>
        </div>
        <div
          v-if="pageCount > 1"
          class="pagination-container justify-content-center"
        >
          <n-pagination
            v-model="pagination.currentPage"
            type="info"
            :page-count="pageCount"
          >
            <template slot="prev">«</template>
            <template slot="next">»</template>
          </n-pagination>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.classic"
      headerClasses="justify-content-center"
      modalClasses="media-modal"
      @close="closeVideo"
    >
      <h4 slot="header" class="title title-up">
        {{ selectedVideo ? selectedVideo.title : 'Video Detail' }}
      </h4>
      <div v-if="selectedVideo" class="video-modal-content">
        <div class="video-embed">
          <iframe
            :src="getEmbedUrl(selectedVideo.url)"
            :title="selectedVideo.title"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <p class="video-modal-category">{{ selectedVideo.category }}</p>
        <p class="video-modal-description">{{ selectedVideo.description }}</p>
      </div>
      <template slot="footer">
        <n-button type="danger" @click.native="closeVideo">
          Close
        </n-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Button, Modal, Pagination, Parallax } from '@/components';
import videos from './data';

export default {
  name: 'landing',
  bodyClass: 'landing-page',
  components: {
    Modal,
    [Pagination.name]: Pagination,
    Parallax,
    [Button.name]: Button
  },
  data() {
    return {
      allVideos: videos,
      searchQuery: '',
      selectedCategory: 'All',
      pagination: {
        currentPage: 1,
        perPage: 12
      },
      modals: {
        classic: false
      },
      selectedVideo: null
    };
  },
  computed: {
    categories() {
      return [...new Set(this.allVideos.map(video => video.category))];
    },
    filteredVideos() {
      const keyword = this.searchQuery.toLowerCase();
      return this.allVideos.filter(video => {
        const matchesCategory =
          this.selectedCategory === 'All' ||
          video.category === this.selectedCategory;

        const matchesKeyword =
          !keyword ||
          [video.title, video.category, video.description].some(value =>
            String(value)
              .toLowerCase()
              .includes(keyword)
          );

        return matchesCategory && matchesKeyword;
      });
    },
    pageCount() {
      return Math.max(
        1,
        Math.ceil(this.filteredVideos.length / this.pagination.perPage)
      );
    },
    paginatedVideos() {
      const start = (this.pagination.currentPage - 1) * this.pagination.perPage;
      const end = start + this.pagination.perPage;
      return this.filteredVideos.slice(start, end);
    }
  },
  methods: {
    setCategory(category) {
      this.selectedCategory = category;
    },
    scrollToPortfolioTop() {
      this.$nextTick(() => {
        const section = this.$el.querySelector('.media-portfolio-section');
        if (!section) return;

        const offset = 40;
        const top =
          section.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      });
    },
    openVideo(video) {
      this.selectedVideo = video;
      this.modals.classic = true;
    },
    closeVideo() {
      this.modals.classic = false;
      this.selectedVideo = null;
    },
    getEmbedUrl(url) {
      const videoId = this.extractYouTubeId(url);
      return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
    },
    getThumbnailUrl(url) {
      const videoId = this.extractYouTubeId(url);
      return videoId
        ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
        : 'img/media.jpg';
    },
    extractYouTubeId(url) {
      if (!url) return '';

      const match = url.match(
        /(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtube\.com\/shorts\/|youtu\.be\/)([^&?/]+)/
      );

      return match ? match[1] : '';
    }
  },
  watch: {
    searchQuery() {
      this.pagination.currentPage = 1;
    },
    selectedCategory() {
      this.pagination.currentPage = 1;
    },
    'modals.classic'(isOpen) {
      if (!isOpen) {
        this.selectedVideo = null;
      }
    },
    filteredVideos() {
      if (this.pagination.currentPage > this.pageCount) {
        this.pagination.currentPage = this.pageCount;
      }
    },
    'pagination.currentPage'(newPage, oldPage) {
      if (newPage !== oldPage) {
        this.scrollToPortfolioTop();
      }
    }
  }
};
</script>
<style scoped>
:deep(.modal-dialog.media-modal) {
  max-width: 1000px;
  width: calc(100% - 2rem);
}

.media-portfolio-section {
  padding-bottom: 70px;
}

.media-inquiry {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 32px;
  padding: 26px 30px;
  border: 1px solid #dcecf8;
  border-radius: 16px;
  background: #f3f9fe;
}

.media-inquiry-copy h2 {
  margin: 0 0 6px;
  color: #283b4d;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.5;
}

.media-inquiry-copy p {
  margin: 0;
  color: #637587;
  font-size: 0.9rem;
  line-height: 1.6;
}

.media-inquiry-link {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 46px;
  padding: 12px 20px;
  border-radius: 10px;
  background: #2ca8ff;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.5;
  text-decoration: none;
  transition: background-color 0.2s ease;
}

.media-inquiry-link:hover {
  background: #087bbf;
  color: #fff;
  text-decoration: none;
}

.media-inquiry-link:focus-visible {
  outline: 3px solid #087bbf;
  outline-offset: 4px;
}

.media-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 34px;
}

.media-search {
  position: relative;
  flex: 1 1 420px;
  max-width: 540px;
}

.media-search i {
  position: absolute;
  top: 50%;
  left: 18px;
  color: #adb5bd;
  transform: translateY(-50%);
}

.media-search .form-control {
  height: 54px;
  padding-left: 48px;
  margin-bottom: 0;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 999px;
}

.media-result-count {
  margin-bottom: 0;
  color: #6c757d;
  font-weight: 600;
}

.media-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 28px;
}

.media-filter-btn {
  padding: 10px 18px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 999px;
  background: #fff;
  color: #495057;
  font-size: 0.9rem;
  font-weight: 600;
  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.media-filter-btn:hover {
  border-color: rgba(44, 168, 255, 0.35);
  color: #2ca8ff;
}

.media-filter-btn.active {
  border-color: #2ca8ff;
  background: #2ca8ff;
  color: #fff;
  box-shadow: 0 12px 24px rgba(44, 168, 255, 0.24);
}

.media-card {
  height: 100%;
  margin: 0;
  overflow: hidden;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 20px 45px rgba(44, 62, 80, 0.12);
  cursor: pointer;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.media-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 54px rgba(44, 62, 80, 0.18);
}

.media-grid-row > [class*='col-'] {
  margin-bottom: 32px;
}

.media-thumb-wrapper {
  position: relative;
  aspect-ratio: 16 / 9;
  background: #111;
}

.media-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.media-play {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 1.8rem;
  transform: translate(-50%, -50%);
}

.media-card-body {
  padding: 24px;
}

.media-card-body h3 {
  margin-bottom: 12px;
  font-size: 1.35rem;
}

.media-category {
  margin-bottom: 10px;
  color: #2ca8ff;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.media-summary {
  margin-bottom: 0;
  color: #6c757d;
  white-space: pre-line;
}

.media-empty {
  padding: 30px 0 10px;
}

.media-empty p {
  color: #6c757d;
}

.video-modal-content {
  width: 100%;
}

:deep(.pagination-container) {
  margin-top: 26px;
}

.video-embed {
  position: relative;
  margin-bottom: 20px;
  padding-top: 56.25%;
  overflow: hidden;
  border-radius: 12px;
  background: #111;
}

.video-embed iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.video-modal-category {
  margin-bottom: 8px;
  color: #2ca8ff;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.video-modal-description {
  margin-bottom: 0;
  white-space: pre-line;
}

:deep(.media-modal .modal-footer) {
  justify-content: flex-end;
}

@media (max-width: 767px) {
  .media-inquiry {
    align-items: stretch;
    flex-direction: column;
    gap: 18px;
    padding: 22px;
  }

  :deep(.modal-dialog.media-modal) {
    width: calc(100% - 1rem);
  }

  .media-toolbar {
    margin-bottom: 28px;
  }

  .media-grid-row > [class*='col-'] {
    margin-bottom: 24px;
  }
}
</style>
